import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import { DiscountStoreItemImportModel, IDiscItemImportTemplate, IlocationList, IImportLbl } from '../../../../core/models';
import { FormGroup, FormControl, FormBuilder } from '@angular/forms';
import { GridDataResult, PageChangeEvent, DataStateChangeEvent, IsEmptyFilterOperatorComponent } from '@progress/kendo-angular-grid';
import { orderBy, process, State, SortDescriptor } from '@progress/kendo-data-query';
import { GridSettings, Info } from '../../../../core/common';
import { ISampleFinish, ISampleSubCategory, ISampleCategory, IGetSampleProductOrderDetailsByHeader, IGetSampleSubCategoryCostBySubcategoryId, IDiscItem, IMasterData, DiscItem } from '../../../../core/models';
import { AdminService } from '../../../../core/services/admin.service';
import { ProductSampleFulfillmentService } from '../../../../core/services/product-sample-fulfillment.service';
import { SuccessEvent, SelectEvent, FileRestrictions } from '@progress/kendo-angular-upload';

import { Subject } from 'rxjs';
import { AppNotifyService } from '../../../../core/services/app-notify.service';
import { NotifyType } from 'src/app/core/enums/NotifyType';
import { Router } from '@angular/router';
import { environment } from 'src/environments/environment';
import { DiscountStoreService } from '../../../../core/services/discount-store.service';
import * as Excel from 'exceljs/dist/exceljs.min.js';
import { Location } from '@angular/common';
import * as ExcelProper from "exceljs";
import * as fs from 'file-saver';

@Component({
  selector: 'app-import-discount-store-item',
  templateUrl: './import-discount-store-item.component.html',
  styleUrls: ['./import-discount-store-item.component.scss']
})
export class ImportDiscountStoreItemComponent implements OnInit {
  rawData: any;
  priceHistoryGridView: GridDataResult;
  isPriceHistory: boolean = false;

  constructor(private adminService: AdminService, private formBuilder: FormBuilder,
    private appNotifyService: AppNotifyService, private productSampleFulfillmentService: ProductSampleFulfillmentService,
    private discountStoreService: DiscountStoreService,
    private location: Location,
    private router: Router) { }
  importLblTxt: IImportLbl;
  //#region label declaration
  public import = {
    uploadItemToExcelLbl: 'Upload Items From Excel',
    excelFileUploadLbl: 'Requirement for Excel file upload',
    importContentLbl1: 'You may add any contents (like text) in row 1. Contents for row 1 will not be uploaded',
    importContentLbl2: 'Data from row 2 upto row 1000 will be uploaded.',
    importContentLbl3: ' Column 1 must be the item name and column 2 must be item quantity.',
    importContentLbl4: 'Any aditional columns after column 2 will be iqnored.',
    importContentLbl5: 'A maximum of 999 items can be uploaded at one time from Excel. Any rows after row 1000 in the Excel file will be ignored.',
    importContentLbl6: 'To upload more than 999 items, you must upload them in multiple batches with a maximum of 999 items at a time.',
    importContentLbl7: 'Note that you can not upload configured items or kit items.',
    importContentLbl8: 'Item quantity (column 2) must be between 1 to 999.',
    importContentLbl9: 'A sheet name is mandatory.Enter the correct sheet name.',
    importContentLbl10: 'To download a sample Excel file,',
    importContentLbl11: 'Enter the Excel Details below',
    clickLbl: 'Click',
    uploadLbl: 'Upload',
    importSuccessMessageLbl: 'Uploading.......',
    importSuccessMessageLbl1: 'All Item successfully added to Cart',
    errorMessage: 'Cannot use multiple files',
  }
  labelTexts = {
    longItemNumber: "Long Item #",
    shortItemNumber: "Item #",
    categoryName: "Item #",
    subCategoryDescription: "Description",
    description: "Description",
    colorCode: "Location",
    location: "Location",
    stockNum: "Available Qty",
    avlQty: "Available Qty",
    currentCostId: "Base Price",
    basePrice: "Base Price",
    cost: "Cost",
    discount: "Discount",
    salePrice: "Sale Price",
    finishCode: "Finish",
    size: "Size",
    paintCode: "Paint",


    maxQtyCanBeOrdered: "Max Qty",
    maxQtyCanBeOrderedAddText: "Max Quantity",

    stockNumAddText: "Stock Number",

    currentInventory: "Inventory",
    currentInventoryAddText: "Current Inventory",
    reorderPoint: "Reorder Point",
    stockingLevel: "Stocking Level",
    ec: "EC",
    onBackOrder: "On Backorder",
    isActive: "IsActive",
    resetTo: "Reset To",
    adjustment: "Adjustment +/-",
    isExternal: "External",
    isPDM: "PDM Only",
    action: "Actions",
    fileupload: "File Upload",
    urlLbl: "Url",
    skulbl: "SKU",
    updateAction: "Update",
    historyAction: "History",
    infoCategoryText: "*Note: This will update the existing category including the associated products",
    infoMaxQuantityText: "Max Quantity is optional",
    dimensions: "Item Box Dimensions (inches)",
    height: "Height",
    length: "Length",
    width: "Width",
    weight: "Weight(oz)",
    isEmptyCategoryDescription: false,
    isSubmitted: false,

    isEmptyCategory: false,
    isEmptySubCategory: false,
    isEmptyMaxqty: false,
    isEmptysku: false,
    isEmptyFinishCode: false,
    isEmptyFileUpload: false,
    isEmptyStockNum: false,
    isEmptyReorderPoint: false,
    isEmptyCurrentCostId: false,
    isEmptyStockingLevel: false,
    isEmptyCurrentInventory: false,

  }
  //#endregion

  //#region Draft region
  itemReviewGridLoading: boolean = false;
  allItems: IDiscItemImportTemplate[] = [];
  itemGridView: GridDataResult;
  public itemGridstate: State = {
    skip: 0,
    take: 10,
    group: null,
    sort: [{
      field: 'longItemNumber',
      dir: 'desc'
    }],
    filter: {
      logic: 'and',
      filters: []
    },
  };

  async loadItems() {
    try {
      this.allItems = this.importExcelItems;
      console.log(this.allItems);
      this.bindItemGrid();
    }
    catch (err) { }
  }

  public bindItemGrid(): void {
    this.itemGridView = process(this.allItems, this.itemGridstate);
  }

  public itemGridPageChange({ skip, take }: PageChangeEvent) {
    this.itemGridstate.skip = skip;
    this.itemGridstate.take = take;
    this.bindItemGrid();
  }

  public itemGridSortChange(sort): void {
    this.itemGridstate.sort = sort;
    this.bindItemGrid();
  }
  initGridState() {
    this.itemGridstate.skip = 0;
    this.itemGridstate.take = 10;
  }

  public itemGridGridDataStateChange(state: DataStateChangeEvent): void {
    this.itemGridstate = state;
    this.bindItemGrid();
  }

  //#endregion

  ngOnInit() {
    this.importExcelItems = [];
    this.readyForUpload = false;
  }


  public importExcelItems: IDiscItemImportTemplate[] = [];
  public async readExcel(event) {
    this.initFormForNewExcelImport();
    if (!event.target || !event.target.value) { return; }
    const target: DataTransfer = (event.target) as DataTransfer;
    console.log("target.files.length=", target.files.length);
    console.log("target.files=", target.files);
    if (target.files.length !== 1) {
      this.appNotifyService.notify(NotifyType.ERROR, 'Please use correct file.');
      return;
    }
    const arryBuffer = new Response(target.files[0]).arrayBuffer();
    this.importExcelItems = await this.readExcelBuffer(arryBuffer);
    console.log(this.importExcelItems);
    //this.readExcelCompleted();
  }

  public readExcelBuffer(arryBuffer): IDiscItemImportTemplate[] {
    const tempImportExcelItems: IDiscItemImportTemplate[] = [];
    const workbook = new Excel.Workbook();
    let c = this.importExcelItems;
    let d = this.tl;
    let p = this;
    arryBuffer.then(function (data) {
      workbook.xlsx.load(data)
        .then(function () {
          //console.log(workbook);
          const worksheet = workbook.getWorksheet(1);
          //console.log('rowCount: ', worksheet.rowCount);
          worksheet.eachRow(function (row, rowNumber) {
            if (rowNumber > 1) {
              tempImportExcelItems.
                push(({
                  longItemNumber: row.values[1] ? row.values[1].toString() : '',
                  itemNumber: row.values[1] ? row.values[1].toString() : '',
                  description: row.values[2] ? row.values[2].toString() : '',
                  finishCode: row.values[3] ? row.values[3].toString() : '',
                  size: row.values[4] ? row.values[4].toString() : '',
                  paintCode: row.values[5] ? row.values[5].toString() : '',
                  availableLocName: row.values[6] ? row.values[6].toString() : '',
                  basePrice: row.values[7],
                  discount: row.values[8],
                  salePrice: row.values[9],
                  currentInventory: row.values[10],
                  cost: row.values[11],
                  actionText: 'Pending Upload'
                }) as IDiscItemImportTemplate);
            }
          });
          console.log(tempImportExcelItems);
          c = tempImportExcelItems;
          //d();
          p.refreshGrid();
          return tempImportExcelItems;
        });
    });
    return tempImportExcelItems;
  }

  initFormForNewExcelImport() {
    this.itemReviewGridLoading = true;
    this.readyForUpload = true;
    this.uploadInProgress = false;
    this.initGridState();
  }

  tl = function () {
    this.loadItems();
    this.itemReviewGridLoading = false;
  }

  refreshGrid() {
    this.loadItems();
    this.itemReviewGridLoading = false;
  }

  importType: any = "modify";
  readyForUpload: boolean = false;
  uploadInProgress: boolean = false;
  uploadSummaryText: string = '';
  async validateItems() {
    //do serverside item validation
    let data: DiscountStoreItemImportModel = new DiscountStoreItemImportModel();
    data.ops = 'validate';
    try {
      let resp = await this.discountStoreService.validateItemsForImport(data).toPromise();
      console.log(resp);
    }
    catch (err) { }
  }
  async uploadItems() {
    if (this.uploadInProgress) {
      //this.appNotifyService.notify(NotifyType.ERROR, 'Upload in progress.');
      return;
    }
    //all client side validation is done, ready for final upload
    let data: DiscountStoreItemImportModel = new DiscountStoreItemImportModel();
    data.ops = this.importType;
    if (this.importExcelItems.length < 1) {
      this.appNotifyService.notify(NotifyType.ERROR, 'Nothing to upload.');
      return;
    }
    data.items = this.importExcelItems;
    this.uploadInProgress = true;
    try {
      let resp = await this.discountStoreService.bulkUploadItems(data).toPromise();
      console.log(resp);
      //success
      this.importExcelItems = resp.data.items;
      this.importExcelItems.forEach((el, index) => {
        el.actionText = el.importValidationNotes;
      })
      this.readyForUpload = false;
      this.uploadInProgress = false;
      this.loadItems();
      //this.uploadSummaryText = 'Total item for upload=' + resp.data.items.length + '.';
      //this.uploadSummaryText = 'Successfull upload=' + resp.data.items.filter;

    }
    catch (err) {
      this.appNotifyService.notify(NotifyType.ERROR, 'Sorry an error occured while uploading. Please try again.');
      this.uploadInProgress = true;
    }
  }

  importTypeChanged(ev) {
    console.log('upp');
    console.log(ev);
    //this.readyForUpload = true;
    //this.uploadInProgress = false;
    //this.initGridState();
  }

  goBack() {
    this.location.back();
  }

  downloadingAllItems: boolean = false;
  allItemsInDB: IDiscItemImportTemplate[] = [];
  locList: IlocationList[] = [];
  async generateExcel() {
    this.locList = await this.discountStoreService.getLocationList().toPromise();
    this.downloadingAllItems = true;
    let workbook: ExcelProper.Workbook = new Excel.Workbook();
    let worksheet = workbook.addWorksheet('Sheet1');
    let worksheetLocations = workbook.addWorksheet('LocationsList');
    const header = ['ItemNumber', 'Description', 'FinishCode', 'Size', 'PaintCode', 'AvailableLocName', 'BasePrice',
      'Discount', 'SalePrice', 'CurrentInventory','Cost'];
    const headerLoc = ['LocationName'];
    //Add Header row
    let headerRow = worksheet.addRow(header);
    let headerLocRow = worksheetLocations.addRow(headerLoc);
    worksheetLocations.addRow([]);
    this.locList.forEach(q => {
      worksheetLocations.addRow([q.name]);
    });
    await this.loadActiveItems();
    let tempLocationNames = this.locList.map(x => x.name);
    this.allItemsInDB.map(p =>
    ([
      p.itemNumber,
      p.description,
      p.finishCode,
      p.size,
      p.paintCode,
      p.availableLocName,     
      p.basePrice,
      p.discount,
      p.salePrice,
      p.currentInventory,
      p.cost
    ])
    ).forEach(d => {
      let row = worksheet.addRow(d);
    });
    let joineddropdownlist = "\"" + tempLocationNames.join(',') + "\"";
    for (let i = 2; i < (this.allItemsInDB.length + 2); i++){
        worksheet.getCell('F'+i).dataValidation = { 
        type: 'list',
        allowBlank: true,
        formulae: [joineddropdownlist]
        };
    }
    worksheet.addRow([]);
    workbook.xlsx.writeBuffer().then((data) => {
      let blob = new Blob([data], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
      fs.saveAs(blob, 'Disc-Store-Import-Item-Template.xlsx');
    })
    this.downloadingAllItems = false;
  }


  async loadActiveItems() {
    try {
      let resp = await this.discountStoreService.getAllItems().toPromise();
      this.allItemsInDB = resp;
      this.allItemsInDB = this.allItemsInDB.filter(x => x.isActive)
    }
    catch (err) { }
  }


  // #region Price History

  public priceHistoryState: State = {
    skip: 0,
    take: 10,
    group: null,
    sort: [{
      field: 'createdDate'
    }]
  };

  public async processPriceHistoryGridData(dataItem) {
    console.log("dataItem: ", dataItem);
    // data call here
    this.discountStoreService.getPriceHistoryForItem(dataItem).subscribe(resp => {

      console.log(resp); // data comes here without issue
      this.rawData = resp;
      console.log("price hist data: ", this.rawData);
      this.rawData = [{ date: "4/22/2025", price: 25 }, { date: "4/20/2025", price: 20 }, { date: "4/18/2025", price: 18 }];
      this.bindPriceHistoryGrid();

      this.openPriceHistory();
    })



       
  }

  bindPriceHistoryGrid() {
    this.priceHistoryGridView = process(this.rawData, this.priceHistoryState);
  }

  public closePriceHistory(): void {
    this.isPriceHistory = false;
  }
  public openPriceHistory(): void {
    this.isPriceHistory = true;
  }

  // #endregion

}
